export interface TechnicalFeaturesGetApiRequest {
    task_id: string;
}

export interface TechnicalFeatures {
    feature_elements: string
    feature_function: string
    feature_num: string
    /**
     * 拆解的特征(原始文本)
     */
    feature_text_original: string
    /**
     * 特征类型 topic (主题技术特征) 打勾 旗子
     * core (区别技术特征) 打勾 旗子
     * public (现有技术特征) 打勾
     */
    feature_weight: 'topic' | 'core' | 'public' | ''
    /**
     * 特征权重原因
     */
    feature_weight_reason: string
    selected: boolean
    /**
     * 是否用户添加
     */
    user_add: boolean
    /**
     * 技术特征组成部分
     */
    components?: string[]
}
export interface TechnicalFeaturesGetApiResponse {
    data: TechnicalFeatures[]
}

/**
 * 异步技术特征获取响应
 */
export interface TechnicalFeaturesGetAsyncResponse {
    /**
     * 任务状态：SUCCESS, FAILED, RUNNING
     */
    status: 'SUCCESS' | 'FAILED' | 'RUNNING';
    /**
     * 技术特征数据（当 status 为 SUCCESS 时返回）
     */
    result?: TechnicalFeaturesGetApiResponse;
    /**
     * 错误信息（当 status 为 FAILED 时返回）
     */
    error_message?: string;
    /**
     * 任务ID
     */
    task_id: string;
}

/**
 * 技术特征获取 API
 */
export interface TechnicalFeaturesGetApi {
    /**
     * 获取技术特征
     * @param data 请求参数
     * @param signal abort 信号
     * @returns 异步技术特征响应
     */
    getTechnicalFeatures(data: TechnicalFeaturesGetApiRequest, signal?: AbortSignal): Promise<TechnicalFeaturesGetAsyncResponse>;
}

export const TechnicalFeaturesGetApi = Symbol.for('TechnicalFeaturesGetApi');
